import { Translate } from 'ra-core';

export const PayrollMethodsList = (t: Translate) => [
  { id: 'daily-increase', name: t('resources.company.payroll_method.method_daily_increase') },
  { id: 'static', name: t('resources.company.payroll_method.method_static') },
];

export const MapPayrollMethods = (type: string, t: Translate) => {
  if (type === 'daily-increase') {
    return t('resources.company.payroll_method.method_daily_increase');
  }

  if (type === 'static') {
    return t('resources.company.payroll_method.method_static');
  }
};
